<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Item', to: '/ax/items' },
      { label: 'Add New' }
    ]" title="New Item" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-3">
      <div class="w-1/2">
        <h4 class="font-bold text-xl leading-7 mb-4 block">Create New Single AX</h4>
        <div class="mb-3 mr-1.5">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Item Name
          </label>
          <multiselect v-model="itemId" label="name" track-by="name" placeholder="type to find item..."
            open-direction="bottom" :options="items" :searchable="true" :loading="isLoadingItemSearch"
            :close-on-select="true" @search-change="findItemName">
            <span slot="noResult">
              Oops! No elements found. Consider changing the search query.
            </span>
          </multiselect>
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Name
          </label>
          <input id="basePrice" type="text" v-model="name" placeholder="Enter Name"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Base Price
          </label>
          <input id="basePrice" type="number" v-model="basePrice" placeholder="Enter Base Price"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Single ID AX
          </label>
          <input id="basePrice" type="number" v-model="single_idax" placeholder="Enter Single ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mt-3 mr-1.5">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor
          </label>
          <multiselect v-model="vendor" label="name" track-by="name" placeholder="type to find vendor..."
            open-direction="bottom" :options="items_vendor" :searchable="true" :loading="isLoadingSearch"
            :close-on-select="true" @search-change="findVendorName" @input="getVendorAx">
            <span slot="noResult">
              Oops! No elements found. Consider changing the search query.
            </span>
          </multiselect>
        </div>
        <div class="mt-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor ID AX
          </label>
          <input id="basePrice" type="text" v-model="vendor_id_ax" placeholder="Vendor ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class=" mt-4 mb-3 mr-0 flex justify-start">
          <button @click="addSingleAx()" class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button>
          <button type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
            <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm"
              :to="{ path: '/ax/items' }">
              Cancel
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { mapActions, mapState } from 'vuex';
import { AxItemPath } from '../../router/content';
import {EventBus} from '../../event-bus'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs'
export default {
  name: 'CreateSingleAX',
  components: {
    HeaderBreadcrumbs
  },
  data() {
    return {
      AxItemPath,
      itemid_label: null,
      itemId: [],
      items: [],
      isLoadingItemSearch: false,
      name: null,
      basePrice: null,
      single_idax: null,
      vendor: [],
      items_vendor: [],
      isLoadingSearch: false,
      vendor_id_ax: null,
    };
  },
  watch: {
    successMessage: function () {
      if (!this.successMessage) return;
      //this.alertMsg(this.successMessage, 'success');
      EventBus.$emit('show-toast', {
            message:'New Item has been added.',
            type: 'success',
          });
      this.$router.push('/ax/items');
    },
    errorMessage: function () {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    },
    isError: function () {
      if (!this.isError) return;
      EventBus.$emit('show-toast', {
            message:'Ops. Something went wrong !',
            type: 'success',
          });
    },

    itemId: function () {
      if (!this.itemId) return;
      this.name = this.itemId?.name
      this.itemid_label = this.itemId?.id
    },

    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Create Single AX | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.ItemSoax.isLoading,
      isError: (state) => state.ItemSoax.isError,
      successMessage: (state) => state.ItemSoax.successMessage,
      errorMessage: (state) => state.ItemSoax.errorMessage,
      itemsEbook: (state) => state.ebooks.items,
    }),
  },
  methods: {
    ...mapActions('ItemSoax', ['createSingleAx']),
    ...mapActions('vendors', ['findVendor', 'fetchVendorsById']),
    ...mapActions('ebooks', ['searchBooks']),

    addSingleAx() {
      const payload = {
        item_id: this.itemId?.id,
        name: this.name,
        base_price: this.basePrice,
        single_idax: this.single_idax,
        vendor: this.vendor ? this.vendor?.name : null,
        publisher: this.vendor ? this.vendor?.name : null,
        vendor_id_ax: this.vendor_id_ax,
      };
      this.createSingleAx(payload);
    },

    findItemName(keyword) {
      if (keyword.length > 2) {
        this.isLoadingItemSearch = true;
        let payload = {
          q: keyword,
        };
        this.searchBooks(payload)
          .then(() => {
            this.items = this.itemsEbook
            this.isLoadingItemSearch = false;
          })
          .catch((err) => {
            this.isLoadingItemSearch = false;
            console.log(err);
          });
      }
    },

    findVendorName(keyword) {
      if (keyword.length > 2) {
        this.isLoadingSearch = true;
        let payload = {
          q: keyword,
        };
        this.findVendor(payload)
          .then((resp) => {
            this.items_vendor = resp.data.data;
            this.isLoadingSearch = false;
          })
          .catch((err) => {
            this.isLoadingSearch = false;
            console.log(err);
          });
      }
    },

    getVendorAx() {
      this.fetchVendorsById(this.vendor).then((res) => {
        this.vendor_id_ax = res.data?.data?.sync_vendor?.vendor_id_ax;
      });
    },
  },
};
</script>